// Copyright (c) BSS-ONE
// Author: Alexandru Bagu (a.bagu at software-dep.net)

<template>
  <a-spin :spinning="loading">
    <table-view
      :columns="columns"
      :data="rows"
      size="small"
      rowKey="id" />
    <a-modal
      :title="modTitle + ' ' + this.selectedAppliance.name"
      :visible="modApplianceModalVisible"
      :confirm-loading="modApplianceModalConfirmLoading"
      @ok="modAppliance"
      @cancel="modApplianceModalClose">
      <a-form
        :ref="(el) => { this.mod_ref = el; }"
        :model="mod_form"
        :rules="mod_rules"
        layout="vertical">
        <a-row ><a-col :xl="24">
          <span>{{ this.modSubtitle }}</span>
          <div style="margin-top: 15px" v-if="modType !== 'disconnect'">
            <span>{{ $t('message.select.a.workspace.user') }}</span><br/>
            <a-form-item :label="this.$t('label.user')" name="user_id">
              <a-select
                v-model:value="mod_form.user_id"
                showSearch
                optionFilterProp="children"
                :filterOption="filterOption"
                :options="userSelectOptions"
                @change="onSelectUserId"
              ></a-select>
            </a-form-item>
          </div>
        </a-col></a-row>
      </a-form>
    </a-modal>
  </a-spin>
</template>

<script>
import { mixinDevice } from '@/utils/mixin.js'
import { h, reactive } from 'vue'
import Status from '@/components/widgets/Status'
import TableView from '@/components/view/TableView'
import AnsibleMixin from './AnsibleMixin'
import _ from 'lodash'
import { Tooltip, Button } from 'ant-design-vue'
import { MoreOutlined, DeleteOutlined, CopyOutlined, UserAddOutlined, UserDeleteOutlined, UsergroupAddOutlined, UsergroupDeleteOutlined, DisconnectOutlined } from '@ant-design/icons-vue'

export default {
  name: 'WorkspaceAppliances',
  components: {
    Status,
    TableView
  },
  mixins: [mixinDevice, AnsibleMixin],
  props: {
    workspaceId: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      columns: [],
      rows: [],
      loading: true,
      virtualmachines: [],
      resource: {},
      selectedAppliance: {},

      modType: '',
      modTitle: '',
      modSubtitle: '',
      modApplianceModalVisible: false,
      modApplianceModalConfirmLoading: false,
      mod_data: {
        user_id: null
      },
      mod_form: {},
      mod_ref: null,
      mod_rules: null,

      user_id: null,
      user: null,
      users: [],
      isAdmin: false
    }
  },
  computed: {
    userSelectOptions () {
      return this.users.map((user) => {
        return {
          label: user.name,
          value: user.id
        }
      })
    }
  },
  created () {
    this.buildTable(h)
  },
  mounted () {
    this.fetchData()
    this.init_mod_form()
  },
  methods: {
    buildTable (h) {
      var that = this
      that.isAdmin = that.isAdminRole()
      this.columns = [{
        dataIndex: 'id_x',
        title: this.$t('label.id')
      }, {
        dataIndex: 'name',
        title: this.$t('label.name'),
        customRender: function ({ text, record, index }) {
          let copyPassword = ''
          if (that.isAdmin) {
            copyPassword =
              <span>
                {h(Tooltip, { placement: 'bottom' }, {
                  title: () => <span>{that.$t('label.copy.root.username')}</span>,
                  default: () => h(Button, {
                    shape: 'circle',
                    type: 'secondary',
                    style: { 'margin-right': '2px', 'margin-bottom': '2px' },
                    onClick: () => that.copyUsername(record)
                  }, <CopyOutlined />)
                })}
                {h(Tooltip, { placement: 'bottom' }, {
                  title: () => <span>{that.$t('label.copy.root.password')}</span>,
                  default: () => h(Button, {
                    shape: 'circle',
                    type: 'primary',
                    style: { 'margin-right': '2px', 'margin-bottom': '2px' },
                    onClick: () => that.copyPassword(record)
                  }, <CopyOutlined />)
                })}
              </span>
          }
          const disconnectSession = that.resource.brokerType === 'horizon' ? h(Tooltip, { placement: 'bottom' }, {
            title: () => <span>{that.$t('label.workspace.disconnect.appliance')}</span>,
            default: () => h(Button, {
              shape: 'circle',
              type: 'secondary',
              style: { 'margin-right': '2px', 'margin-bottom': '2px' },
              onClick: () => that.triggerModAppliance('disconnect', record)
            }, <DisconnectOutlined />)
          }) : ''
          const assignVm = h(Tooltip, { placement: 'bottom' }, {
            title: () => <span>{that.$t('label.workspace.assign.appliance')}</span>,
            default: () => h(Button, {
              shape: 'circle',
              type: 'primary',
              style: { 'margin-right': '2px', 'margin-bottom': '2px' },
              onClick: () => that.triggerModAppliance('assign', record)
            }, <UserAddOutlined />)
          })
          const unassignVm = h(Tooltip, { placement: 'bottom' }, {
            title: () => <span>{that.$t('label.workspace.unassign.appliance')}</span>,
            default: () => h(Button, {
              shape: 'circle',
              type: 'dashed',
              style: { 'margin-right': '2px', 'margin-bottom': '2px' },
              onClick: () => that.triggerModAppliance('unassign', record)
            }, <UserDeleteOutlined />)
          })
          const addAdmin = h(Tooltip, { placement: 'bottom' }, {
            title: () => <span>{that.$t('label.workspace.add-admin.appliance')}</span>,
            default: () => h(Button, {
              shape: 'circle',
              type: 'primary',
              style: { 'margin-right': '2px', 'margin-bottom': '2px' },
              onClick: () => that.triggerModAppliance('add-admin', record)
            }, <UsergroupAddOutlined />)
          })
          const removeAdmin = h(Tooltip, { placement: 'bottom' }, {
            title: () => <span>{that.$t('label.workspace.remove-admin.appliance')}</span>,
            default: () => h(Button, {
              shape: 'circle',
              type: 'dashed',
              style: { 'margin-right': '2px', 'margin-bottom': '2px' },
              onClick: () => that.triggerModAppliance('remove-admin', record)
            }, <UsergroupDeleteOutlined />)
          })
          const deleteVm = h(Tooltip, { placement: 'bottom' }, {
            title: () => <span>{that.$t('label.workspace.remove.appliance')}</span>,
            default: () => h(Button, {
              shape: 'circle',
              type: 'danger',
              style: { 'margin-right': '2px', 'margin-bottom': '2px' },
              onClick: () => that.removeAppliance(record)
            }, <DeleteOutlined />)
          })
          if (record.type === 'appliance') {
            return <span>
              <span>{text}</span>
              <span style="float: right">
                {h(Tooltip, { placement: 'top', overlayStyle: { 'z-index': 0 } }, {
                  title: () => <div> {disconnectSession} {assignVm} {unassignVm} {addAdmin} {removeAdmin} {copyPassword} {deleteVm} </div>,
                  default: () => <a-button type="dashed" shape="circle"><MoreOutlined /></a-button>
                })}
              </span>
            </span>
          } else if (record.type === 'vdi') {
            return <span>
              <span>{text}</span>
              <span style="float: right">
                {h(Tooltip, { placement: 'top', overlayStyle: { 'z-index': 0 } }, {
                  title: () => <div> {disconnectSession}  {assignVm} {unassignVm} {addAdmin} {removeAdmin} {copyPassword}  </div>,
                  default: () => <a-button type="dashed" shape="circle"><MoreOutlined /></a-button>
                })}
              </span>
            </span>
          } else if (copyPassword) {
            return <span>
              <span>{text}</span>
              <span style="float: right">
                {h(Tooltip, { placement: 'top', overlayStyle: { 'z-index': 0 } }, {
                  title: () => <div> {copyPassword}  </div>,
                  default: () => <a-button type="dashed" shape="circle"><MoreOutlined /></a-button>
                })}
              </span>
            </span>
          } else {
            return <span>
              <span>{text}</span>
            </span>
          }
        }
      }, {
        dataIndex: 'type',
        title: this.$t('label.type'),
        customRender: function ({ text, record, index }) {
          var txt = record.type
          if (txt === 'ad-server') {
            txt = 'DC'
          } else if (text === 'broker') {
            txt = 'Broker'
          } else if (text === 'appliance') {
            txt = 'Appliance'
          } else {
            txt = 'VDI'
          }
          return <a-tag>{txt}</a-tag>
        }
      }, {
        dataIndex: 'vmUuid',
        title: this.$t('label.vm'),
        customRender: function ({ text, record, index }) {
          return h('router-link', { props: { to: { path: '/vm/' + record.vmUuid } } }, record.vmname || record.vmUuid)
        }
      }]
    },
    init_mod_form () {
      this.mod_form = reactive({ user_id: '' })
      this.mod_rules = reactive({ user_id: [{ required: true, message: `${this.$t('message.error.select')}` }] })
    },
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toUpperCase().indexOf(input.toUpperCase()) >= 0
      )
    },
    triggerModAppliance (type, appliance) {
      this.modType = type
      this.modTitle = this.$t('label.workspace.' + type + '.appliance')
      if (type === 'disconnect') {
        this.modSubtitle = this.$t('label.workspace.' + type + '.appliance.subtitle')
      } else {
        this.modSubtitle = ''
      }
      this.selectedAppliance = appliance
      this.modApplianceModalVisible = true
    },
    modApplianceModalClose () {
      this.modApplianceModalVisible = false
    },
    async modAppliance () {
      var that = this
      that.modApplianceModalConfirmLoading = true
      that.mod_ref.validateFields().then(async () => {
        var appliance = JSON.parse(JSON.stringify(that.selectedAppliance))
        var user = JSON.parse(JSON.stringify(that.user))
        that.modApplianceModalVisible = false
        that.init_mod_form()
        await that.startApplianceModificationProcess(this.modType, user, appliance, that.resource)
        that.modApplianceModalConfirmLoading = false
      }).catch(err => {
        that.addModalConfirmLoading = false
        that.formRef.scrollToField(err.errorFields[0].name)
        if (err) {
          that.$notification.error({
            message: that.$t('message.request.failed'),
            description: that.$t('error.form.message')
          })
        }
      })
    },
    async startApplianceModificationProcess (action, user, appliance, workspace) {
      if (!user && action !== 'disconnect') { return }
      var tempAnsibleParams = await this.getAnsibleBaseParams(workspace)
      this.copyObject(user, tempAnsibleParams, 'user')
      this.copyObject(appliance, tempAnsibleParams, 'appliance')

      var ansibleParams = this.convertNamespaces(tempAnsibleParams)
      var paramBase64 = this.encodeVars(ansibleParams)

      var ansibleTask = await this.asyncApi('ansibleStartTaskAsync', { playbook: action + '-workspace-appliance', vars: paramBase64 })
      await this.waitForTask(ansibleTask.ansiblestarttaskasyncresponse.jobid, this.$t('label.workspace.appliance.modification.start.setup'), this.$t('error.fetching.async.job.result'), this.$t('label.workspace.appliance.modification.end.setup'))
    },
    async removeAppliance (appliance) {
      var that = this
      this.$confirm({
        title: that.$t('label.delete') + ' ' + appliance.name,
        content: that.$t('label.confirm.workspace.delete.appliance'),
        icon: 'exclamation-circle',
        okType: 'danger',
        onOk: function () {
          setTimeout(async function () {
            var baseParams = await that.getAnsibleBaseParams(that.resource)
            that.copyObject(appliance, baseParams, 'appliance')
            var ansibleParams = that.convertNamespaces(baseParams)
            var paramBase64 = that.encodeVars(ansibleParams)

            var ansibleTask = await that.asyncApi('ansibleStartTaskAsync', { playbook: 'remove-workspace-appliance', vars: paramBase64 })
            await that.waitForTask(ansibleTask.ansiblestarttaskasyncresponse.jobid, that.$t('label.workspace.appliance.remove.start'), that.$t('error.fetching.async.job.result'), that.$t('label.workspace.appliance.remove.end'))
            that.$emit('triggerRefresh')
          })
        }
      })
    },
    copyUsername (vm) {
      this.copyToClipboard(vm.username)
      this.$notification.success({
        message: this.$t('label.success'),
        duration: 0.5
      })
    },
    copyPassword (vm) {
      this.copyToClipboard(vm.password)
      this.$notification.success({
        message: this.$t('label.success'),
        duration: 0.5
      })
    },
    onSelectUserId (value) {
      this.user_id = value
      var users = this.users.filter((user, idx) => {
        return user.id === value
      })
      if (users && users.length) {
        this.user = users[0]
      } else {
        this.user = null
        this.user_id = value
      }
    },
    async fetchData (_users) {
      if (!this.workspaceId) return
      this.loading = true
      let json = await this.asyncApi('workspaceApplianceList', { workspace_uuid: this.workspaceId })
      var listVirtualMachines = this.asyncApi('listVirtualMachines', { listall: true, filter: 'id,name' })
      var listVirtualMachinesJson = await listVirtualMachines
      if (listVirtualMachinesJson) {
        this.virtualmachines = listVirtualMachinesJson.listvirtualmachinesresponse.virtualmachine
      }
      var workspaceGetJson = await this.asyncApi('workspaceGet', { uuid: this.workspaceId })
      if (workspaceGetJson) {
        this.resource = workspaceGetJson.workspaceresponse.payload.workspaces[0]
      }
      var vms = json.workspaceappliancelistresponse.payload.appliances
      vms.sort((a, b) => (a.id > b.id) ? 1 : -1)
      this.rows.splice(0, this.rows.length)
      _.map(vms, (responseItem, responseKey) => {
        var vm = responseItem
        vm.id_x = responseKey + 1
        for (var i = 0; i < this.virtualmachines.length; i++) {
          var rvm = this.virtualmachines[i]
          if (rvm.id === vm.vmUuid) {
            vm.vmname = rvm.name
          }
        }
        this.rows[responseKey] = vm
      })
      var users = _users
      if (!users) {
        json = await this.asyncApi('workspaceUserList', { workspace_uuid: this.resource.uuid })
        users = json.workspaceuserlistresponse.payload.users
      }
      this.users.splice(0, this.users.length)
      _.map(users, (responseItem, responseKey) => {
        this.users[responseKey] = responseItem
      })
      this.loading = false
    }
  }
}
</script>
